import React, { useState } from 'react';
import apiClient from '@/api';
import { Modal, Button, Form } from 'react-bootstrap'; // Assuming you use react-bootstrap

export default function StartMessageModal({ show, handleClose, recipientId, recipientName }) {
    const [messageBody, setMessageBody] = useState('');
    const [isSending, setIsSending] = useState(false);

    const handleSend = async () => {
        if (!messageBody.trim()) return;

        setIsSending(true);
        try {
            await apiClient.post('/messages/start', {
                recipient_id: recipientId,
                body: messageBody,
            });
            // TODO: Add a toast notification for "Message Sent!"
            handleClose();
            setMessageBody('');
        } catch (error) {
            console.error("Failed to start conversation:", error);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Message {recipientName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        value={messageBody}
                        onChange={(e) => setMessageBody(e.target.value)}
                        placeholder="Type your message..."
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSend}
                    disabled={!messageBody.trim() || isSending}
                >
                    {isSending ? 'Sending...' : 'Send Message'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
